import { createFileRoute } from '@tanstack/react-router';
import { accountantDetailsQueryOptions } from '@/api/accountant.api.ts';
import { MainPortalLayout } from '@/layouts/MainPortalLayout/MainPortalLayout.tsx';
import { getAccountantExternalId } from '@/contexts/accountantExternalId.ts';

export const Route = createFileRoute('/_index')({
  component: MainPortalLayout,
  loader: ({ context }) => {
    const externalId = getAccountantExternalId();
    if (externalId) {
      return context.queryClient.ensureQueryData(accountantDetailsQueryOptions(externalId));
    }
  },
});
